import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  List,
  Paragraph
} from '@eggplant/pattern-library'
import { testCaseDashboard } from '../../docs-routes'
import { useModule } from '@eggplant/routing'

const TestCaseDashboard = () => {
  const [isMonitorFlag] = useModule()

  const headerTitle = isMonitorFlag
    ? 'Monitor test case dashboard'
    : 'Test case dashboard'

  return (
    <>
      <Paragraph>
        <Color variant='theme-description-text'>
          {headerTitle} provides an overview of your script-based tests. You can easily access and analyze aggregated data for all your test cases from here.
        </Color>
        <br />
        <br />
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Key Features:
        </Color>
        <br />
      </Paragraph>
      <List variant='description'>
        <Paragraph>
          <Color variant='theme-description-text'>
            View test case results per day over a specified period, allowing you to track performance trends.
          </Color>
        </Paragraph>
        <Paragraph>
          <Color variant='theme-description-text'>
            Gain insights through percentage summaries of test case result statuses, helping you assess overall test outcomes.
          </Color>
        </Paragraph>
        <Paragraph>
          <Color variant='theme-description-text'>
            Analyze the slowest running, most failed, and errored test cases for focused investigation.
          </Color>
        </Paragraph>
      </List>
      <br />
      <Paragraph>
        <Color variant='theme-description-text'>
          Customize Your View:
        </Color>
        <br />
        <br />
      </Paragraph>
      <List variant='description'>
        <Paragraph>
          <Color variant='theme-description-text'>
            Filter the dashboard according to your specific needs.
          </Color>
        </Paragraph>
        <Paragraph>
          <Color variant='theme-description-text'>
            Set up a date range to analyze test performance over a specific period.
          </Color>
        </Paragraph>
        <Paragraph>
          <Color variant='theme-description-text'>
            Choose to filter by a specific model or suite to narrow down the results to the desired scope.
          </Color>
        </Paragraph>
      </List>
      <br />
      <Paragraph>
        <Color variant='theme-description-text'>
          With the Test Case Dashboard, you have a powerful tool to review, analyze, and gain valuable insights from your test case data, empowering you to make informed decisions and optimize your testing processes.
        </Color>
        <DocusaurusFooter path={testCaseDashboard} />
      </Paragraph>
    </>
  )
}

export default TestCaseDashboard
